import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.minRows = parseInt(this.element.getAttribute("rows"), 10) || 3

    this._onInput = this.resize.bind(this)
    this._onVisibility = this.handleVisibilityChange.bind(this)

    this.element.addEventListener("input", this._onInput)

    this.hasBeenSized = this.isVisible()
    window.addEventListener("tabs:switched", this._onVisibility)

    if (this.hasBeenSized) this.resize()
  }

  disconnect() {
    this.element.removeEventListener("input", this._onInput)
    window.removeEventListener("tabs:switched", this._onVisibility)
  }

  handleVisibilityChange() {
    if (!this.hasBeenSized && this.isVisible()) {
      this.resize()
      this.hasBeenSized = true
    }
  }

  resize() {
    const element = this.element
    if (!this.isVisible()) return

    const lineHeight = parseFloat(getComputedStyle(element).lineHeight)
    const minHeight = this.minRows * lineHeight

    element.style.height = "auto"
    const newHeight = Math.max(element.scrollHeight, minHeight) + 2
    element.style.height = `${newHeight}px`
  }

  isVisible() {
    return this.element.offsetParent !== null
  }
}
